// ==============================|| OVERRIDES - LINK ||============================== //

export default function Tooltip() {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1em',
          color: 'black',
          backgroundColor: '#b6a19e'
        }
      }
    }
  };
}
